import { render, staticRenderFns } from "./ClienteDestinazioni.vue?vue&type=template&id=52d4be44"
import script from "./ClienteDestinazioni.vue?vue&type=script&lang=js"
export * from "./ClienteDestinazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports